<template>
  <section class="coach-profile">
    <!-- Lightbox -->
    <vue-easy-lightbox
      v-if="coach"
      :visible="isLightboxVisible"
      :imgs="lightboxImg"
      @hide="isLightboxVisible = false"
    />
    <!-- Dialog components -->
    <LoginPopup
      :dialog="isLoginPopup"
      @close-dialog="closeDialog('loginPopun')"
    />
    <BookCoachDialog
      v-if="coach"
      :coachId="coach._id"
      :dialog="isBookClicked"
      :isLive="isLive"
      :packId="selectedProduct"
      @close-dialog="closeDialog('bookCoach')"
    />
    <v-progress-linear
      v-if="loading && !coach"
      indeterminate
      color="primary"
    ></v-progress-linear>

    <!-- -->
    <v-container grid-list-md v-if="coach">
      <v-row>
        <!-- BADGE COACH -->
        <v-col md="3" order-md="1">
          <div class="profile-card">
            <!-- Profile image -->
            <v-img
              cover
              class="profile-avatar"
              :aspect-ratio="1"
              :alt="coach.name"
              @click="
                isLightboxVisible = true;
                lightboxImg = coach.photoUrl;
              "
              :lazy-src="photoConvert(coach.photoUrl)"
              :src="photoConvert(coach.photoUrl)"
            ></v-img>
            <!-- Profile name / ddescription -->
            <v-card-title>
              <span class="profile-card-name">{{ coach.name }}</span>
              <v-card-text class="mx-2 profile-card-description">
                {{
                  coach.description ||
                  "ce coach n'a aucun description pour le moment"
                }}
              </v-card-text>
            </v-card-title>

            <v-list dense>
              <!-- <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="prix-seance">
                    Prix: {{ coach.coach.sessionPrice }} dt /séance
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->

              <!-- <v-list-item v-if="coach.coach.sessionLocation.length > 0">
                <v-list-item-icon>
                  <v-icon color="#E91E24">mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Lieu de la séance :
                  <v-list-item-title
                    v-for="(item, i) in coach.coach.sessionLocation"
                    :key="i"
                  >
                   {{ item }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->
              
              <!-- <SocialMedia
                :facebook="coach.facebook"
                :instagram="coach.instagram"
                :website="coach.website"
                :youtube="coach.youtube"
              /> -->
            </v-list>
            <v-flex xs12 fill-height>
              <v-card justify-center wrap flat class="text-center pa-2">
                Notez {{ coach.name }}
                <v-rating></v-rating>
              </v-card>
            </v-flex>
          </div>
        </v-col>

        <v-col md="9" order-md="2">
          <v-row no-gutters>
            <!-- A propos -->
            <v-col cols="12" md="12">
                <!--
                <p class="font-weight-bold d-flex justify-content-end pl-4">
                  A propos de {{ coach.name }}
                </p>
                -->
                <v-row>
                  <v-col
                    cols="4"
                    class="d-flex-inline-block justify-content-end pl-4"
                    style="padding: 0 0 15px 0;"
                  >
                    <ScrollCard
                      title="Spécialités"
                    >
                      <div v-if="coach.coach.specialities.length > 0">
                        <p
                          class="body-2"
                          style="margin-bottom: 2px"
                          v-for="(item, i) in coach.coach.specialities"
                          :key="i"
                        >
                          {{ item }}
                        </p>
                      </div>
                      <p
                        v-else
                        class="body-2 text--secondary"
                        style="margin-bottom: 2px"
                      >
                        aucune spécialité mentionnée
                      </p>
                    </ScrollCard>
                    <!-- Card -->
                    <!--
                    <div class="scroll-card">
                      <span class="title">Spécialités</span>
                    </div>
                    <div v-if="coach.coach.specialities.length > 0">
                      <p
                        class="body-2"
                        style="margin-bottom: 2px"
                        v-for="(item, i) in coach.coach.specialities"
                        :key="i"
                      >
                        {{ item }}
                      </p>
                    </div>
                    <p
                      v-else
                      class="body-2 text--secondary"
                      style="margin-bottom: 2px"
                    >
                      aucune spécialité mentionnée
                    </p>
                    -->
                    <!-- Card -->
                  </v-col>
                  <v-col
                    cols="4"
                    class="d-flex-inline-block justify-content-end pl-4"
                    style="padding: 0 0 15px 0;"
                  >
                    <ScrollCard
                      title="Equipement"
                    >
                      <div v-if="coach.coach.equipments.length > 0">
                        <p
                          class="body-2"
                          style="margin-bottom: 2px"
                          v-for="(item, i) in coach.coach.equipments"
                          :key="i"
                        >
                          {{ item }}
                        </p>
                      </div>
                      <p
                        v-else
                        class="body-2 text--secondary"
                        style="margin-bottom: 2px"
                      >
                        pas d'équipements
                      </p>
                    </ScrollCard>
                  </v-col>
                  <v-col 
                    cols="4"
                    class="d-flex-inline-block justify-content-end pl-4"
                    style="padding: 0 0 15px 0;"
                  >
                    <ScrollCard
                      title="Expérience"
                    >
                      <div v-if="coach.coach.experience.length > 0" >
                        <ShowCoachExperience
                          :experiences="coach.coach.experience"
                          :coachName="coach.fullName"
                        />
                      </div>
                    </ScrollCard>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col 
                    cols="12" 
                    md="6"
                    class="d-flex-inline-block justify-content-end pl-4"
                    style="padding: 0 0 15px 0;"
                  >
                    <div class="d-flex justify-content-end">
                      <DatePicker
                        title="Vérifier la disponibilité du coach"
                      ></DatePicker>
                    </div>
                  </v-col>
                  <v-col 
                      cols="12" 
                      md="6"
                      class="d-flex-inline-block justify-content-end pl-4"
                      style="padding: 0 0 15px 0; display: flex !important; justify-content: space-between;" 
                    >
                    
                      <Pack
                        v-for="(pack, i) in coach.coach.packs"
                        :disabled="requestState"
                        @pushLogin="pushLoginForm"
                        @order-coach-clicked="onOrderCoach(pack._id)"
                        :key="i"
                        :price="pack.price"
                        :packId="pack._id"
                        :color="pack.name == 'Premium' ? 'amber accent-4' : 'primary'"
                        
                        :title="pack.name"
                        :data="[
                          { label: 'Nombre des sessions', 
                            value: pack.nbrSessions 
                          },
                          {
                            label: 'Première séance gratuite',
                            value: pack.freeFirst,
                          },
                        ]"
                        type="type"
                      />

                  </v-col>
                </v-row>
            </v-col>
            
            <!--
            <v-col cols="12">
              <div no-gutters class="d-flex justify-center">
                
              </div>
            </v-col>
            -->
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SocialMedia from "@/components/SocialMediaWidget.vue";
import ShowCoachExperience from "@/components/coachComponents/ShowCoachExperience.vue";
import DisponibilityCard from "@/components/coachComponents/DisponibiltyCard.vue";
import GradientButton from "@/components/UI/GradientButton";
import BookCoachDialog from "@/components/coachComponents/BookCoachDialog";
import LoginPopup from "@/components/authentication/LoginPopup";
import Pack from "@/components/business/Pack";
import ScrollCard from "@/components/UI/ScrollCard";
import DatePicker from "@/components/DatePicker";
import coachMixins from "@/mixins/coachMixins.js";

export default {
  mixins: [coachMixins],
  data() {
    return {
      isLive: false,
      isBookClicked: false,
      isLoginPopup: false,
      isLightboxVisible: false,
      lightboxImg: "",
      selectedProduct: null,
    };
  },
  components: {
    SocialMedia,
    ShowCoachExperience,
    DisponibilityCard,
    GradientButton,
    BookCoachDialog,
    LoginPopup,
    Pack,
    ScrollCard,
    DatePicker
  },
  beforeMount() {
    this.getCoach(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      getCoach: "loadCoachById",
    }),
    onOrderCoach(packId) {
      this.selectedProduct = packId;
      this.isLive = true;
      this.isBookClicked = true;
    },
    photoConvert(url) {
      if (url === null || url === undefined) {
        return process.env.VUE_APP_API_URL_COACH_AVATAR;
      }
      if (url.startsWith("https://sprint-app.com")) return url;
      else return url + "?height=500";
    },
    closeDialog(type) {
      if (type == "bookCoach") this.isBookClicked = false;
      else this.isLoginPopup = false;
    },
    onBookCoach(type) {
      if (this.isLoggedIn) {
        this.isLive = type;
        this.isBookClicked = true;
      } else this.pushLoginForm();
    },
  },
  computed: {
    ...mapGetters({
      coach: "getCoachById",
      loading: "loading",
      user: "user",
      isLoggedIn: "isLoggedIn"
    }),
    
    requestState() {
      if (this.user && this.user.requests)
        return this.user.requests.coach.includes(this.$route.params.id) || null;
      else return false;
    },
  },
};
</script>

<style scoped>
.coach-profile {
  background: #f5f5f5;
  padding-bottom: 70px;
}
.profile-card {
  background: #fff;
  height: auto;
  border: 1px solid #e2e2e2;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}
.profile-avatar {
  width: 130px;
  height: 130px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin: auto;
  margin-top: 25px;
  cursor: pointer;
}
.profile-card-name {
  text-align: center;
  display: block;
  margin: auto;
  font-weight: 600;
}
.profile-card-description {
  text-align: center;
  padding-top: 5px;
}
.contactBtn {
  margin: auto;
  color: #fff !important;
  background: #e91e24 !important;
}
.v-card__title {
  border-bottom: 1px solid #ddd;
  padding-bottom: 25px;
}
.prix-seance {
  text-align: center;
  font-size: 17px !important;
  font-weight: 600 !important;
  color: #e91e24;
}
.v-rating {
  padding-bottom: 20px;
}
</style>